<template>
<div id="facturas_transito_transportista">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container grid-list-md text-xs-center>

        <v-flex xs12>
            <base-material-card color="primary" icon="library_books" title="Bitácora CFDI Comercio Exterior" class="elevation-1 px-5 py-3">

                        <v-card-text>
                            <v-card-title>
                                <span class="headline"></span>
                            </v-card-title>
                            <v-form ref="form1" lazy-validation>
                                <v-container grid-list-md text-xs-center>

                                    <v-row row wrap>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                        model.fecha_de = parseDate(model.fecha_de)
                                                                        " v-mask="'####-##-##'" :rules="[
                                                                        rules.required,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        ]">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu1 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu1 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                            rules.required,
                                                            validaDias,
                                                            validaFecha,
                                                            ]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>

                                        <v-col sm="12" md="2" lg="2">
                                         <v-switch
                                            v-model="fecha_factura"
                                            color="red darken-3"
                                            label="Fecha de Emisión"
                                        ></v-switch>
                                        </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                             &nbsp;
                                          </v-col>
                                    </v-row>
                                    <v-row row wrap>
                                        <v-col sm="12" md="8" lg="8" v-if="es_grupo==0">
                                            <v-autocomplete :hide-no-data="true" :items="gruposTransportistas" v-model="rfc_grupo_seleccionado"
                                                :item-text="getNombreGrupo" item-value="rfc" clearable label="Seleccione Emisor" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="8" lg="8" v-else >
                                            <v-autocomplete :hide-no-data="true" :items="clientesTransportista" v-model="rfc_cliente_seleccionado"
                                                :item-text="getNombreCliente" item-value="rfc" clearable label="Seleccione Cliente" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                            &nbsp;
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                            &nbsp;
                                        </v-col>
                                    </v-row>
                                    <v-row row wrap>
                                        <v-col sm="12" md="8" lg="8">
                                            <v-autocomplete :hide-no-data="true" :items="tiposComprobante" v-model="model.tipo_comprobante" clearable
                                                item-text="nombre" item-value="nombre" label="Seleccione Tipo de Comprobante" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                             <v-btn rounded color="success" @click="get_data_view()" :loading="loading">
                                                <v-icon>done</v-icon>Vista Previa
                                            </v-btn>
                                          </v-col>
                                          <v-col sm="12" md="2" lg="2">
                                             &nbsp;
                                          </v-col>
                                    </v-row>

                                </v-container>
                            </v-form>
                            <v-card>
                                <v-card-actions v-if="data_resumen.length>0">
                                  <v-btn v-if="to_download.length > 0 && permiso_renombrar " rounded color="red" @click="modal_rename=true;">
                                    <v-icon>done</v-icon>Cambiar Referencia
                                  </v-btn>
                                  <v-btn v-if="to_download.length > 0 && permiso_asignar " rounded color="success" @click="modal_asignar_masivo=true;">
                                    <v-icon>done</v-icon>Asignar Transportista Masivo
                                  </v-btn>
                                    <v-spacer></v-spacer>
                                    <exportar-excel :data="datafiltered" :exportFields="data_resumen_excel" name="Resumen_Facturas_Transito.xlsx">
                                        <v-btn dark small color="success" title="Exportar Resumen" v-tippy>
                                            <v-icon dark>get_app</v-icon> Exportar a Excel
                                        </v-btn>
                                    </exportar-excel>

                                </v-card-actions>
                                <v-card-text>

                                    <v-client-table id="vuetabledetalle" ref="vuetabledetalle" :data="data_resumen" :columns="columns_resumen" :options="options_resumen" class="elevation-2 pa-2 scroll-table">
                                        <template slot="noResults">
                                            <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                        </template>
                                        <div slot="filter__id" >
                                          <input type="checkbox" class="form-control check-all" v-model='allChecked' @change="check_all()" >
                                        </div>
                                        <template slot="id" slot-scope="props">
                                          <div style="display:flex; justify-content:center;" >
                                            <input :id="props.row.id+'_'+props.row.id_factura_pedimento" type="checkbox" v-model="to_download" :value="props.row.id+'_'+props.row.id_factura_pedimento" ></input>
                                          </div>
                                        </template>

                                        <template slot="rfc_grupo" slot-scope="props" >
                                            <div v-if="es_grupo==0 && permiso_asignar" @click="openModalAsignar(props.row)"
                                                :class="['showPerfil']" >
                                                {{ getRfcGrupo(props.row.rfc_grupo) }}
                                            </div>
                                            <div v-else>
                                                {{ props.row.rfc_grupo }}
                                            </div>
                                        </template>

                                          <template slot="tipo_documento" slot-scope="props">
                                            <div style="display:flex; justify-content:center;">
                                               {{props.row.tipo_documento.substring(0, 25)}}
                                            </div>
                                        </template>
                                         <template slot="importe" slot-scope="props">
                                            <div style="display:flex; justify-content:right;">
                                               {{props.row.importe}}
                                            </div>

                                        </template>


                                        <template slot="actions_view" slot-scope="props">
                                            <v-btn x-small fab dark color="purple"
                                                v-if="props.row.key_pdf==null || props.row.key_pdf==''"
                                                @click="verFacturaProforma(props.row.rfc, props.row.filename)"
                                                title="Factura Proforma" v-tippy>
                                                <v-icon>receipt</v-icon>
                                            </v-btn>
                                            <v-btn x-small fab dark color="purple"
                                                v-if="props.row.key_pdf!=null && props.row.key_pdf!=''"
                                                @click="downloadProforma(props.row.key_pdf)"
                                                title="Factura Proforma2" v-tippy>
                                                <v-icon>receipt</v-icon>
                                            </v-btn>&nbsp;
                                            <v-btn x-small fab dark color="secondary"
                                                @click="downloadFile(props.row.rfc, props.row.folder + '/' + props.row.folder + '_' + props.row.filename)"
                                                title="Descargar" v-tippy>
                                                <v-icon>mdi-download</v-icon>
                                            </v-btn>&nbsp;
                                            <v-btn v-if="permiso_eliminar" x-small fab dark color="red" @click="deleteFile(props.row.id)" title="Eliminar" v-tippy>
                                                <v-icon>delete</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-client-table>
                                </v-card-text>
                            </v-card>
                        </v-card-text>


            </base-material-card>
        </v-flex>

    </v-container>
    <v-dialog v-model="dialog1" max-width="500px">
        <v-card>
            <v-card-text>
                <h5>Ingrese lista de ordenes de compra</h5>
                <span>Uno por línea</span>
                <v-form ref="formListado" lazy-validation="">
                    <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required, maxListaRule]"></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="model.lista='';dialog1 = false">Cancelar</v-btn>
                <v-btn small color="primary" @click="setListValues();">Buscar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modal_asignar" max-width="500px">
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text">receipt</v-icon>&nbsp;Asignar Transportista
                </v-card>
            </v-card-title>
            <v-card-text>
                <v-form ref="formAsignar" lazy-validation="">

                    <v-autocomplete :hide-no-data="true" :items="gruposTransportistas" v-model="rfc_grupo_asignar"
                        :rules="[rules.required]" :item-text="getNombreGrupo" item-value="rfc"
                        label="Seleccione Transportista" ></v-autocomplete>

                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="row_selected={};modal_asignar = false">Cancelar</v-btn>
                <v-btn small color="primary" @click="asignarTransportista();">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modal_asignar_masivo" max-width="500px">
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text">receipt</v-icon>&nbsp;Asignar Transportista
                </v-card>
            </v-card-title>
            <v-card-text>
                <v-form ref="formAsignar" lazy-validation="">

                    <v-autocomplete :hide-no-data="true" :items="gruposTransportistas" v-model="rfc_grupo_asignar"
                        :rules="[rules.required]" :item-text="getNombreGrupo" item-value="rfc"
                        label="Seleccione Transportista" ></v-autocomplete>

                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="row_selected={};modal_asignar_masivo = false">Cancelar</v-btn>
                <v-btn small color="primary" @click="asignarTransportistaMasivo();">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Modal Factura Proforma -->
    <v-dialog v-model="modalProforma" width="65%" max-width="100%">
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text">receipt</v-icon>&nbsp;Factura Proforma
                </v-card>
            </v-card-title>

            <v-divider></v-divider>
            <v-card-text>

                    <v-container grid-list-md >
                        <v-layout wrap>
                            <v-flex xs12>
                                <div id="facturaProforma">
                                    <div style="text-align:center;font-size:12px;font-weight:bold;line-height:12px!important;">
                                        <span></span>
                                    </div><br>
                                    <div style="font-size:11px;">
                                        <table id="tablaGenerales" width="100%">
                                            <tr>
                                                <td width="49%">
                                                    <table>
                                                        <tr>
                                                            <th width="30%">RFC emisor:</th>
                                                            <td width="70%">{{model_proforma.RFC}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Nombre emisor:</th>
                                                            <td>{{model_proforma.Nombre}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Folio:</th>
                                                            <td>{{model_proforma.Folio}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>RFC receptor:</th>
                                                            <td>{{model_proforma[" RFC"]}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Nombre receptor:</th>
                                                            <td>{{model_proforma[" Nombre"]}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Uso CFDI:</th>
                                                            <td>{{model_proforma.UsoCFDI}}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="2%"></td>
                                                <td width="49%">
                                                    <tr>
                                                        <th width="35%">Folio fiscal:</th>
                                                        <td width="65%">{{model_proforma["Folio Fiscal"]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>No. de serie del CSD:</th>
                                                        <td>{{model_proforma["No Certificado"]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Código postal, fecha y hora de emisión:</th>
                                                        <td>{{model_proforma["Lugar de Expedicion"]}} {{model_proforma["Fecha"]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Efecto de comprobante:</th>
                                                        <td>{{model_proforma["Tipo de Comprobante"]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Régimen fiscal:</th>
                                                        <td>{{model_proforma["Regimen Fiscal"]}}</td>
                                                    </tr>
                                                </td>
                                            </tr>
                                        </table>
                                        <br/>
                                        <span style="font-weight:bold;font-size:12px;">Conceptos</span>
                                        <br><br>
                                        <table id="tablaMercancias" border=1>
                                            <tr style="text-align:center;background-color:#DCDBDA;">
                                                <th width="10%">Clave del producto y/o servicio</th>
                                                <th width="10%">No. identificación</th>
                                                <th width="9%">Cantidad</th>
                                                <th width="8%">Clave de unidad</th>
                                                <th width="10%">Unidad</th>
                                                <th width="10%">Valor unitario</th>
                                                <th width="10%">Importe</th>
                                                <th width="10%">Descuento</th>
                                                <th width="11%">No. de pedimento</th>
                                                <th width="11%">No. de cuenta predial</th>
                                            </tr>
                                            <template v-for="(concepto) in model_proforma.conceptos">
                                                <tr>
                                                    <td>{{concepto["Clave Prod Serv"]}}</td>
                                                    <td>{{concepto["No Identificacion"]}}</td>
                                                    <td>{{formatNumber(concepto["Cantidad"],2)}}</td>
                                                    <td>{{concepto["Clave Unidad"]}}</td>
                                                    <td>{{concepto["Unidad"]}}</td>
                                                    <td>{{formatNumber(concepto["Valor Unitario"],2)}}</td>
                                                    <td>{{formatNumber(concepto["Subtotal"],2)}}</td>
                                                    <td></td>
                                                    <td>{{concepto["Pedimento"]}}</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th style="text-align:center;background-color:#DCDBDA;">Descripción</th>
                                                    <td colspan=4 style="vertical-align:middle !important; text-align:left !important;">{{concepto["Descripcion"]}}</td>
                                                    <td colspan=5>
                                                        <table id="TablaImpuestos" width="100%">
                                                            <tr>
                                                                <th>Impuesto</th>
                                                                <th>Tipo</th>
                                                                <th>Base</th>
                                                                <th>Tipo Factor</th>
                                                                <th>Tasa o Cuota</th>
                                                                <th>Importe</th>
                                                            </tr>
                                                            <tr v-if="concepto['Impuesto Traslado']!=''">
                                                                <td>{{concepto["Impuesto Traslado"]}}</td>
                                                                <td>Traslado</td>
                                                                <td>{{formatNumber(concepto["Subtotal"],2)}}</td>
                                                                <td>{{concepto["Tipo Factor Traslado"]}}</td>
                                                                <td>{{ concepto["TasaOCuota Traslado"]>0 ? formatNumber(concepto["TasaOCuota Traslado"]*100,4):concepto["TasaOCuota Traslado"]}}%</td>
                                                                <td style="text-align:right !important;">{{formatNumber(concepto["Importe Traslado"],2)}}</td>
                                                            </tr>
                                                            <tr v-if="concepto['Impuesto Retencion']!=''">
                                                                <td>{{concepto["Impuesto Retencion"]}}</td>
                                                                <td>Retencion</td>
                                                                <td>{{formatNumber(concepto["Subtotal"],2)}}</td>
                                                                <td>{{concepto["Tipo Factor Retencion"]}}</td>
                                                                <td>{{ concepto["TasaOCuota Retencion"]>0 ? formatNumber(concepto["TasaOCuota Retencion"]*100,4):concepto["TasaOCuota Retencion"]}}%</td>
                                                                <td style="text-align:right !important;">{{formatNumber(concepto["Importe Retencion"],2)}}</td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </template>

                                        </table>
                                        <br>
                                        <table id="tablaSubtotales" width="100%">
                                            <tr>
                                                <td width="51%">
                                                    <table width="100%">
                                                        <tr>
                                                            <th width="30%">Moneda:</th>
                                                            <td width="70%">{{model_proforma.Moneda}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Forma de pago:</th>
                                                            <td>{{model_proforma["Forma Pago"]}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Método de pago:</th>
                                                            <td>{{model_proforma["Metodo Pago"]}}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="1%"></td>
                                                <td width="48%">
                                                    <table width="100%">
                                                        <tr>
                                                            <th width="40%">Subtotal:</th>
                                                            <td width="10%">&nbsp;</td>
                                                            <td width="15%">&nbsp;</td>
                                                            <td width="35%" style="text-align:right !important;">$ {{formatNumber(model_proforma["SumatoriaSubtotal"],2)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Impuestos trasladados</th>
                                                            <td>{{model_proforma["NombreImpuestoTraslado"]}}</td>
                                                            <td style="text-align:right !important;">{{ model_proforma["TasaImpuestoTraslado"]>0 ? formatNumber(model_proforma["TasaImpuestoTraslado"]*100,4):model_proforma["TasaImpuestoTraslado"]}}%</td>
                                                            <td style="text-align:right !important;">$ {{formatNumber(model_proforma["Total Impuestos Trasladado"],2)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Impuestos Retenido</th>
                                                            <td>{{model_proforma["NombreImpuestoRetenido"]}}</td>
                                                            <td></td>
                                                            <td style="text-align:right !important;">$ {{formatNumber(model_proforma["Total Impuestos Retenidos"],2)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Total</th>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td style="font-weight:bold;text-align:right !important;">$ {{formatNumber(model_proforma["Total Facturado"],2)}}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                        <br>
                                            <a :href="model_proforma.QRText" target="_blank" ><v-img v-if="qrSrc" :src="qrSrc" aspect-ratio="2" width="150px" height="150px" ></v-img></a>
                                        <br/>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modalProforma=false">
                    <v-icon>cancel</v-icon>&nbsp;Cerrar
                </v-btn>
                <v-btn :loading="loadingBtn" color="success" @click.native="descargarFacturaProforma()">
                    <v-icon>picture_as_pdf</v-icon>&nbsp;Descargar PDF
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modal_rename" min-width="30%" max-width="50%" >
      <v-card>
        <v-card-title>
          <v-card class="primary white--text titulomodal" >
            <v-icon @click.native="modal_rename = false" class="white--text" >cancel</v-icon>&nbsp;
            <span class="subheading" >
              <strong>Cambiar Nombre de Referencia</strong>
            </span>
          </v-card>
        </v-card-title>
        <v-card-text>
          <v-form ref="formreferencia" lazy-validation>
          <v-text-field v-model="referencia_nueva" label="Nombre de Referencia Nueva" :rules="[rules.required]" ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="success" @click="guardar_refencia">Guardar</v-btn>
          <v-btn small @click="modal_rename = false" >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import html2pdf from "html2pdf.js";
import moment from "moment";
import qrCode from 'qrcode';
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    computed: {
        datafiltered() {
            if (this.$refs['vuetabledetalle'] != null)
                return this.$refs.vuetabledetalle.allFilteredData;
            else
                return [];
        },
        permiso_asignar(){
            return (
               this.valida_permiso("Emanifiesto.facturas.asignar") 
            );
        },
        permiso_renombrar(){
            return (
               this.valida_permiso("Emanifiesto.facturas.renombrar") 
            );
        },
         permiso_eliminar(){
            return (
               this.valida_permiso("Emanifiesto.facturas.cargar") 
            );
        }
    },
    components: {
        "v-refresh-button": RefreshButton,
    },
    created: function () {
        this.URL = this.$hostname + "reportes/";
        this.loading = false;
        this.model.usuario = this.$local_storage.get("id_usuario");

        if (this.$local_storage.get("es_transportista") == 1 || this.$local_storage.get("es_agente") == 1) {
            this.model.rfc = this.$local_storage.get("rfc_grupo");
            this.es_grupo = 1;
            this.getClientesTransportista();
        } else {
            this.model.rfc = this.$local_storage.get("rfc");
            this.getTransportistas();
        }


        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario")
            this.permisoEliminar = true;


        this.getTiposDocumentos();

        var f = new Date();
         var f_de = new Date();

              f_de.setDate(f_de.getDate() + 1);



                let y_de = f_de.getFullYear();
                let m_de = f_de.getMonth() + 1;
                let d_de = f_de.getDate();

                if (m_de < 10)
                    m_de = '0' + m_de;
                if (d_de < 10)
                    d_de = '0' + d_de;

                let y = f.getFullYear();
                let m = f.getMonth() + 1;
                let d = f.getDate();


                if (m < 10)
                    m = '0' + m;
                if (d < 10)
                    d = '0' + d;


                this.model.fecha_de = y + "-" + m + "-" + d;
                this.model.fecha_a = y_de + "-" + m_de + "-" + d_de;
    },
    filters: {
        uppercase: function(value) {
            if (!value) return ''
            value = value.toString()
            return value.toUpperCase()
        },
    },
    data: () => ({
        modal_asignar_masivo: false,
        referencia_nueva: "",
        modal_rename: false,
        to_download: [],
        allChecked: false,
        row_selected:{},
        modal_asignar:false,
        rfc_grupo_asignar:"",
        es_grupo:0,
        gruposTransportistas:[],
        clientesTransportista:[],
        rfc_grupo_seleccionado:"",
        rfc_cliente_seleccionado:"",
        permisoEliminar: false,
        tab: null,
        qrSrc: null,
        data_table_impo: [],
        lista_filtrada: [],
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/indext",
            },

            {
                text: "CFDI Cargados",
                disabled: true,
                to: "",
            },
        ],

        update: false,

        file: "",
        cliente: "",
        name_file: "",
        size_file: 0,
        type_file: 'application/zip',
        loadingBtn:false,
        modalProforma: false,
        model_proforma: {
            transportista:'',
            hbl:'',
            contenedor:'',
            facturas:'',
            agente_carga:'',
        },

        to_download: [],
        dialog1: false,
        dialog2: false,
        listado: "",
        datos: [],
        datos_comercio: [],
        allChecked: false,
        columns: [
            "id",
            "fecha_solicitud",
            "usuario_email",
            "nombre_reporte",
            "criterio",
            "fecha_generacion",
            "estatus",
            "error",
            "actions",
        ],
        options: {
            filterable: [
                "id",
                "fecha_solicitud",
                "usuario_email",
                "nombre_reporte",
                "criterio",
                "fecha_generacion",
                "estatus",
                "error",
            ],
            sortable: [
                "id",
                "fecha_solicitud",
                "usuario_email",
                "nombre_reporte",
                "criterio",
                "fecha_generacion",
                "estatus",
                "error",
            ],

            headings: {
                id: "No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",
                criterio: "Criterio de Búsqueda",
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Descargar",
            },
        },
        loading: true,
        loadingReporte: false,
        show_loading: true,
        tiposComprobante:[{"nombre":"Ingreso"},
            {"nombre":"Traslado"}
        ],
        model: {
            rfc: "",
            usuario: "",
            pedimento: "",
            fecha_de: "",
            fecha_a: "",
            tipo_comprobante:"",
            reporte_url: "/reportes_ws/consulta_adjuntos/",
            nombre_reporte: "Facturas en Tránsito",
            tipo: "Facturas Transito",
            tipo_reporte: "",
            archivo: "", //para buscar por nombre de adjunto
            integrado: 0
        },
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        menu5: false,
        menu6: false,
        fecha_factura: false,
        tiposDocumentos: [],
        rules: {
            required: (v) => !!v || "Este campo es requerido",
            numeric: (value) => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            },
        },

        modal: false,
        data_resumen: [],
        data_resumen_excel: {
            "RFC Transportista": "rfc_grupo",
            RFC: "rfc",
            "Nombre Corto":"metadato_cliente",
            Fecha: "fecha",
            Usuario: "nombre_usuario",
            "Nombre de Referencia del Proceso":"nombre_zip",
            Archivo: "filename",
            "No. Reg. Receptor":"receptor_numero",
            "Nombre del Receptor":"receptor_nombre",
            Folio: "folio",
            "Fecha Emisión": "fecha_emision",
            "Tipo CFDI":"tipo_cfdi",
            "Importe":"importe",

        },
        columns_resumen: [
            "id",
            "rfc_grupo",
            "rfc",
            "metadato_cliente",
            "fecha",
            "iniciales",
            "nombre_zip",
            "filename",
            "receptor_numero","receptor_nombre",
            "folio",
            "fecha_emision",
            "tipo_cfdi",
            "importe",
            "actions_view"
        ],
        options_resumen: {
            filterable: [
                "rfc_grupo",
                "rfc","metadato_cliente",
                "fecha",
                "iniciales",
                "nombre_zip",
                "filename",
                "receptor_numero","receptor_nombre",
                "folio",
                "fecha_emision",
                 "tipo_cfdi",
                "importe",
            ],
            orderBy: {
                column: 'fecha',
                ascending: false
            },
            sortable: [
                "id",
                "rfc_grupo",
                "rfc","metadato_cliente",
                "fecha",
                "iniciales",
                "nombre_zip",
                "filename",
                "receptor_numero","receptor_nombre",
                "folio",
                "fecha_emision",
                "tipo_cfdi",
                "importe",
            ],
            headings: {
                "id": "",
                "rfc_grupo":"RFC Transportista",
                "rfc":"RFC",
                "metadato_cliente":"Nombre Corto",
                fecha: "Fecha",
                iniciales: "Usuario",
                "nombre_zip":"Nombre de Referencia del Proceso",
                filename: "Archivo XML",
                "receptor_numero":"No. Reg. Receptor",
                "receptor_nombre":"Nombre del Receptor",
                descripcion: "Tipo de Documento",
                folio: "Folio",
                fecha_emision: "Fecha Emision",
                "tipo_cfdi":"Tipo CFDI",
                "importe":"Importe",
                actions_view: 'Opciones'
            },
        },
    }),
    methods: {
         valida_permiso(permiso) {
          return (
              this.$local_storage.get(permiso) == 100 
            );
        },
        getNombreGrupo:function(row){
            return row.rfc+" - "+row.grupo;
        },
        getTransportistas: function(){
            let data = {
                id_cliente: this.$local_storage.get("id_cliente"),
            };
            axios.post(this.$hostname+ "grupos/get_grupos_rfc/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.gruposTransportistas = res.data;

                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los grupos.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        openModalAsignar: function(row){
            this.row_selected = row;
            if(row.rfc_grupo != null && row.rfc_grupo!="")
                this.rfc_grupo_asignar= row.rfc_grupo;
            else
                this.rfc_grupo_asignar="";
            this.modal_asignar = true;
        },
        asignarTransportista: function(){
            if(this.$refs.formAsignar.validate() ){
                if(this.rfc_grupo_asignar != this.row_selected.rfc_grupo){
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                  //  console.log(this.row_selected);
                    let data = {
                        id: this.row_selected.id,
                        id_factura_pedimento: this.row_selected.id_factura_pedimento,
                        rfc_grupo: this.rfc_grupo_asignar
                    };
                    axios.post(this.$hostname + 'facturas_transportista/asignar_factura_transportista/', data)
                    .then(res => {
                        this.row_selected.rfc_grupo = this.rfc_grupo_asignar;
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El transportista se asignó correctamente.",
                            footer: ""
                        });
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al asignar transportista. Intente nuevamente.",
                            footer: ""
                        });
                        console.log(err);
                    }).then(()=>{
                        this.modal_asignar = false;
                        this.row_selected = {};
                        this.$root.$dialogLoader.hide();
                    });
                } else {
                    this.modal_asignar = false;
                    this.row_selected = {};
                }
            }
        },
        asignarTransportistaMasivo: function(){
            if(this.$refs.formAsignar.validate() ){
                if(this.rfc_grupo_asignar != this.row_selected.rfc_grupo){
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                  //  console.log(this.row_selected);
                    let data = {
                        registros: this.to_download,
                        rfc_grupo: this.rfc_grupo_asignar
                    };
                    axios.post(this.$hostname + 'facturas_transportista/asignar_factura_transportista_masivo/', data)
                    .then(res => {
                        this.row_selected.rfc_grupo = this.rfc_grupo_asignar;
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El transportista se asignó correctamente.",
                            footer: ""
                        });
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al asignar transportista. Intente nuevamente.",
                            footer: ""
                        });
                        console.log(err);
                    }).then(()=>{
                        this.modal_asignar_masivo = false;
                        this.row_selected = {};
                        this.$root.$dialogLoader.hide();
                        this.to_download = [];
                        this.get_data_view();
                    });
                } else {
                    this.modal_asignar_masivo = false;
                    this.row_selected = {};
                    this.to_download = [];
                }
            }
        },
        getRfcGrupo: function (val) {
            if (val !== null) return val;
            else return "Sin Seleccionar";
        },
        getNombreCliente:function(row){
            if(row.metadato!=null && row.metadato!="")
                return row.rfc+" - "+row.metadato;
            else
                return row.rfc+" - "+row.razon_social;
        },
        getClientesTransportista: function(){
            let data = {
                id_grupo: this.$local_storage.get("id_grupo"),
            };
            axios.post(this.$hostname+ "grupos/get_rfcs/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.clientesTransportista = res.data;
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        cargarReportesDS: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Facturas_Transito_SinPedimento"
            };
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                            this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            this.datos[k].criterio = this.getCriterioPredeterminadosDS(this.datos[k].criterio);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes ds.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        getCriterioPredeterminadosDS: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    if (params.tipo_reporte== undefined && params.fecha_de!=undefined ){
                        return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                    } else if (params.tipo_reporte == 1) {
                        return "Pedimento: " + params.pedimento;
                    } else if (params.tipo_reporte == 3) {
                        return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                    } else if (params.tipo_reporte == 4) {
                        return "Búsqueda por listado de pedimentos";
                    }
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }

        },
        createObjectUrl(err, canvas) {
            if (!err) {
                canvas.toBlob((blob) => {
                    this.qrSrc = window.URL.createObjectURL(blob)
                })
            } else {
                console.warn('generateQrCode:ERROR', err)
            }
        },
        pickFile() {
            this.$refs.file_input.click()
        },



        formatNumber: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                return ""
            return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        },
        verFacturaProforma: function(rfc, filename){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var datos = {
                archivo: filename,
                rfc: rfc
            };

            axios.post(this.$hostname + "reportes_ws/get_data_facturas_pedimentos/", datos)
            .then(response => {
                this.model_proforma = response.data;
                window.URL.revokeObjectURL(this.qrSrc)
                qrCode.toCanvas(this.model_proforma.QRText, {}, this.createObjectUrl)
                this.modalProforma = true;
            })
            .catch(error => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los datos de la factura.",
                    footer: ""
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });

        },
        descargarFacturaProformaMETODOANTERIOR: function(){
            this.loadingBtn = true;
            var opt = {
                margin: [0.5, 0.1, 0.5, 0.1], //top, left, bottom, right
                //filename: "Factura_Proforma_"+this.model_proforma.facturas.factura+".pdf",
                filename: this.model_proforma["Folio Fiscal"]+".pdf",
                image: {
                    type: "jpeg",
                    quality: 1
                },
                html2canvas: {
                    scale: 2
                },
                pagebreak: {
                    mode: [ "css", "legacy"]
                },
                jsPDF: {
                    unit: "in",
                    format: "letter",
                    orientation: "portrait", //portrait, landscape
                    compress: false,
                }
            };

            var html = document.getElementById("facturaProforma");
            var thisObj = this;
            html2pdf()
                .set(opt)
                .from(html)
                .save()
                .then(function (pdf2) {
                                    thisObj.loadingBtn = false;
                                })
        },
        downloadProforma: function(key_pdf){
            var datoss3 = {
                id: key_pdf,
                bucket: "facturas.abiertas.econectpro.mx"
            }
            var thisObj = this;
            axios.post(this.$hostname + 's3/download_url/', datoss3)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al generar PDF. Favor de intentar nuevamente.",
                            footer: '',
                        });
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo. Favor de intentar más tarde.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;

                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    this.$root.$dialogLoader.hide();

                });
        },

        downloadFacturaProforma: function(filename, intento=0){
            var nombreZip = filename.toString()+".pdf";
            var key = this.$local_storage.get("rfc")+"/reportes/"+nombreZip;
            var datoss3 = {
                id: key,
                bucket: "production.econnect.ds"
            }

            var thisObj = this;
            axios.post(this.$hostname + 's3/download_url/', datoss3)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        if(intento > 3) {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al generar PDF. Favor de intentar nuevamente.",
                                footer: '',
                            });
                            this.$root.$dialogLoader.hide();
                        } else {
                            setTimeout(function(){
                                thisObj.downloadFacturaProforma(filename, intento+1);
                            }, 10000); //Damos tiempo para generar el zip (10 seg)
                        }

                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo. Favor de intentar más tarde.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;

                    if (mensaje.indexOf("El archivo no existe en S3")!=-1 && intento<=3){
                        setTimeout(function(){
                            thisObj.downloadFacturaProforma(filename, intento+1);
                        }, 10000); //Damos tiempo para generar el zip (10 seg)
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);
                        this.$root.$dialogLoader.hide();
                    }
                });

        },
        descargarFacturaProforma: function(){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var filename = this.model_proforma["Folio Fiscal"];
            var datos = {
                rfc: this.$local_storage.get("rfc"),
                archivo: filename,
                reporte_url: "/reportes_ws/proforma_factura_transito/",
                nombre_reporte: "Proforma Factura en Transito",
                tipo: "Proforma_Factura_Transito",
                usuario: this.$local_storage.get("id_usuario"),
            };
            var thisObj = this;
            axios.post(this.$hostname + "reportes/save_reporte/", datos)
            .then(res => {
                setTimeout(function(){
                    thisObj.downloadFacturaProforma(filename, 1);
                }, 10000); //Damos tiempo para generar el zip (10 seg)
            })
            .catch(error => {
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined){
                    var mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                } else {//Si es un timeout intentamos descargar el archivo
                    setTimeout(function(){
                        thisObj.downloadFacturaProforma(filename, 1);
                    }, 10000); //Damos tiempo para generar el zip (10 seg)
                }
                console.log(error);
            });
        },
        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
        },
        validaFecha: function (fecha) {
            if (fecha == "Invalid date") return "Fecha no válida.";
            else return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            }
            return true;
        },
        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 365)
                    return "Periodo máximo de consulta 365 dias. Favor de verificar.";
            }
            return true;
        },

        validaLista: function () {
            if (this.model.fecha_de == "" && this.model.fecha_a == "") {
                if (this.model.lista != undefined && this.model.lista.length > 0)
                    return true
                else
                    return "La Fecha es requerida cuando no existe lista de ordenes de compra"
            }
            return true;
        },
        getCriterioPredeterminados: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);

                    let c = "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;

                    if (params.lista != undefined && params.lista.length > 0) {
                        c = " Orden: ";

                        params.lista.forEach(function (item) {
                            c += item + " | ";
                            console.log(item);
                        });
                    }

                    return c;

                } else {
                    return "N/A";
                }
            } catch (error) {
                return "N/A-error";
            }

        },
        getEstatus: function (estatus) {
            var arr_estatus = [
                "Pendiente",
                "Encolado",
                "Generado Correctamente",
                "Con Errores",
            ];
            if (estatus in arr_estatus) return arr_estatus[estatus];
            else return "N/A";
        },

        get_data_view: function (opcion = 0) {
            if (!this.$refs.form1.validate() && opcion == 0) {
                //Opción sirve para saltar la validación cuando se busca por listado
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var data = Object.assign({} , this.model);

                data["rfc"] = [data["rfc"]];
                console.log(this.model);
                if(data["tipo_comprobante"]==null)
                    data["tipo_comprobante"]="";

                data["es_grupo"] = this.es_grupo;
                if(this.rfc_grupo_seleccionado!=null && this.rfc_grupo_seleccionado!="")
                    data["rfc_emisor"] = this.rfc_grupo_seleccionado;
                else
                    data["rfc_emisor"] = "";

                if(this.rfc_cliente_seleccionado!=null && this.rfc_cliente_seleccionado!="")
                    data["rfc_cliente"] = this.rfc_cliente_seleccionado;
                else
                    data["rfc_cliente"] = "";

                let selft = this;
                if (data.fecha_de == "") delete data["fecha_de"];
                if (data.fecha_a == "") delete data["fecha_a"];
                data.lista = [];
                data.fecha_factura = this.fecha_factura;
                axios({
                        method: "post",
                        url:  "https://apireportes.econnectpro.mx/reportes/facturas_transportista/",
                        data: data,
                    })
                    .then((res) => {

                        this.data_resumen = res.data;
                        this.data_resumen.forEach(function (r) {
                            r.fecha = r.fecha.substring(0, 10);

                            r.fecha_emision = r.fecha_emision.substring(0, 10);

                             if (r.folio == "" )
                                 r.folio = "No Localizado";

                            let a = r.filename.split("_");
                            r.filename = r.filename.substring(a[0].length + 1) + "." + r.ext;
                            r.folder = a[0];


                            if(r.tipo_documento != "No Localizado")
                              r.tipo_documento = r.tipo_documento + ' - '  + selft.getNombreTipoDocumento(r.tipo_documento);

                            if(r.tipo_documento == "null - ")
                                r.tipo_documento = "No Localizado";

                        });
                        //console.log(res.data);
                        //console.log(res.data.resumen);
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }
        },

        download_files: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var data = {
                rfc: this.model.rfc,
                usuario: this.model.usuario,
                pedimento: this.model.pedimento,
                fecha_de: this.model.fecha_de,
                fecha_a: this.model.fecha_a,
                lista: this.model.lista,
                reporte_url: "/reportes/facturas_abiertas_zip/",
                nombre_reporte: "Zip Facturas en Tránsito Seleccionadas",
                tipo: "Facturas Transito",
                tipo_reporte: 2,
                keys: this.to_download
            };

            if (data.pedimento == '') delete(data['pedimento']);
            if (data.archivo == '') delete(data['archivo']);
            if (data.fecha_de == '') delete(data['fecha_de']);
            if (data.fecha_a == '') delete(data['fecha_a']);
            if (data.lista == '' || data.lista == []) {
                delete(data['lista'])
            } else {
                if (data.tipo_reporte == 4) {
                    data['lista'] = this.get_array_lista(data['lista'])
                }
            }

            axios({
                    method: "post",
                    url: this.$hostname + "reportes/save_reporte/",
                    data: data
                })
                .then(response => {
                    this.to_download = [];
                    if (data.tipo_reporte == 4) {
                        this.model.lista = '';
                        this.lista_filtrada = [];
                    }
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
                        footer: ""
                    });
                })
                .catch(error => {
                    let mensaje;
                    var titulo = "¡Operación no Permitida!";
                    var tipo = "error";
                    if (typeof error.response !== "undefined") {
                        mensaje = error.response.data.mensaje;
                        if (error.response.status == 406) {
                            titulo = "¡Ya existe un reporte en proceso!";
                            tipo = "info";
                        }
                    } else {
                        mensaje = "Ocurrió un error al generar el reporte";
                    }
                    this.$swal({
                        type: tipo,
                        title: titulo,
                        text: mensaje,
                        footer: ""
                    });
                }).then(() => {
                    this.cargar();
                    this.$root.$dialogLoader.hide();
                });
        },
        get_array_lista: function (cadena) {
            let data = cadena.split("\n");
            let newarr = data.filter(a => a.trim() !== '');
            for (var i = 0; i < newarr.length; i++) {
                newarr[i] = newarr[i].trim();
                newarr[i] = newarr[i].replace(',', '');
                newarr[i] = newarr[i].replace('.', '');
                let a = newarr[i].split("_");
            }

            return newarr;
        },

        parseDate(date) {
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        clear_values() {
            this.model.pedimento = "";
            this.model.fecha_de = "";
            this.model.fecha_a = "";
            this.model.archivo = "";
            this.listado = "";
        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        downloadFile: function (rfc, key) {

            let file = rfc + "/" + key;
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            var datos = {
                id: file,
                bucket: "facturas.abiertas.econectpro.mx",
            };
            axios
                .post(this.$hostname + "s3/download_url/", datos)
                .then((res) => {
                    if (typeof res.data !== "undefined") {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: "",
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (
                        error.response != undefined &&
                        error.response.data != undefined &&
                        error.response.data.mensaje != undefined
                    )
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: "",
                    });
                    console.log(error);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        setListValues: function () {
            this.lista_filtrada = [];
            let to_list = this.get_array_lista(this.model.lista);
            for (var i = 0; i < to_list.length; i++) {
                if (this.lista_filtrada.includes(to_list[i])) {
                    continue;
                } else {
                    this.lista_filtrada.push(to_list[i]);
                }
            }
            this.dialog1 = !this.dialog1;
        },
        maxListaRule: function () {
            if (this.model.lista == '' || this.model.lista == undefined || Array.isArray(this.model.lista)) {
                return "Lista vacia";
            }

            let x = this.model.lista.split("\n");

            if (x.length > 50) {
                return "No se puede consultar mas de 50 pedimentos";
            }

            return true;
        },
        getTiposDocumentos: function () {

            var data = {
                tabla: 25,
            };
            axios.post(this.$hostname + "apendices/lista/", data)
                .then(response => {
                    if (response.data != undefined) {
                        this.tiposDocumentos = response.data;
                        this.tiposDocumentos = this.tiposDocumentos.sort(function (a, b) {
                            return a.clave > b.clave;
                        });

                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los tipos de documento.",
                        footer: ""
                    });
                });
        },
        getNombreTipoDocumento: function (tipo) {
            var filtro = this.tiposDocumentos.filter(function (e) {
                return e.clave == tipo;
            });
            if (filtro.length > 0)
                return filtro[0].descripcion;
            else
                return '';
        },
        deleteFile: function (id_archivo) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el archivo ?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id: id_archivo,
                    };
                    axios
                        .post(this.$hostname + "reportes/eliminar_factura_abierta_xml/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El archivo se eliminó correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el archivo. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.get_data_view()
                        });
                }
            });
        },
        async deleteFileAll(id_archivo) {

                    var datos = {
                        id: id_archivo,
                    };
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    await axios
                        .post(this.$hostname + "reportes/eliminar_factura_abierta_xml/", datos)
                        .then((res) => {
                             this.$root.$dialogLoader.hide();
                        })
                        .catch((error) => {

                            console.log(error);
                        });

        },
        deleteLista() {
            let self = this;
             this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar las facturas ?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    self.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    self.datafiltered.forEach(function(r){
                           self.deleteFileAll(r.id);
                    });

                    self.$swal({
                                type: "success",
                                title: "¡Operación Realizada!",
                                text: "Se elimináron los registros correctamente.",
                                footer: "",
                            }).then((result) => {
                        if (result.value) {
                            self.get_data_view();
                        }
                    });

                }
            });


        },

        check_all: function() {
          let arr = this.allChecked ? this.data_resumen.map(row =>  row.id+'_'+row.id_factura_pedimento) : [];

          if (arr.length == 0) {
            this.to_download = [];
          } else {
            for (var i = 0; i < arr.length; i++) {
              if (this.to_download.includes(arr[i])) {
                continue;
              } else {
                this.to_download.push(arr[i]);
              }
            }
          }
        },
        guardar_refencia: function() {
          if(this.$refs.formreferencia.validate()) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            let data = {
              "referencia": this.referencia_nueva,
              "registros": this.to_download,
              "tipo": "cfdi"
            };

            axios
                .post(this.$hostname + "vucem/cambiar_referencia/", data)
                .then((res) => {
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "Los registros se cambiarón correctamente",
                        footer: "",
                    });
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al cambiar los registros. Favor de comunicarse con soporte.",
                        footer: "",
                    });
                    console.log(error);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                    this.get_data_view();
                    this.to_download = [];
                    this.referencia_nueva = "";
                    this.modal_rename = false;
                });
          }
        }
    },
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #eeeeee;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;
}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}

#pdf {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;
}
#facturaProforma {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;
    /* font-weight: bold;    */
    line-height : 12px;
}
#tablaGenerales >>> th, td {
    border: 0 solid white !important;
    vertical-align: top !important;
    text-align: left !important;
}
#tablaMercancias tr td > #TablaImpuestos >>> th{
    border: 0 solid white !important;
    padding-right:2px !important;
    padding-left:2px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias tr td > #TablaImpuestos >>> td{
    border: 0 solid white !important;
    padding-right:2px !important;
    padding-left:2px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias >>> td {
    font-size: 8px;
    text-align: center !important;
    border: 0.1mm solid black !important;
    padding-right:3px !important;
    padding-left:3px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias >>> th {
    font-size: 8px;
    border: 0.1mm solid black !important;
    padding-right:3px !important;
    padding-left:3px !important;
    padding-top:3px !important;
    padding-bottom:3px !important;
}
.showPerfil {
    cursor: pointer;
    border-bottom: 1px dotted blue;
}
</style>
